/*
  <rk-reviews>: Pfeil-Buttons für die horizontal scrollbare Kartenliste.
  Wischen, Trackpad und Tastatur (Liste ist fokussierbar) funktionieren nativ.
*/
if (!customElements.get('rk-reviews')) {
  class RkReviews extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.rk-reviews__list');
      this.prev = this.querySelector('[data-rk-reviews-prev]');
      this.next = this.querySelector('[data-rk-reviews-next]');
      if (!this.list || !this.prev || !this.next) return;

      this.onPrev = () => this.scrollByPage(-1);
      this.onNext = () => this.scrollByPage(1);
      this.onScroll = () => this.sync();
      this.prev.addEventListener('click', this.onPrev);
      this.next.addEventListener('click', this.onNext);
      this.list.addEventListener('scroll', this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.sync());
      this.resizeObserver.observe(this.list);
      this.sync();
    }

    disconnectedCallback() {
      this.prev?.removeEventListener('click', this.onPrev);
      this.next?.removeEventListener('click', this.onNext);
      this.list?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
    }

    scrollByPage(direction) {
      const card = this.list.querySelector('.rk-reviews__card');
      const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
      const step = card ? card.offsetWidth + gap : this.list.clientWidth;
      const perPage = Math.max(1, Math.floor(this.list.clientWidth / step));
      this.list.scrollBy({ left: direction * step * perPage });
    }

    sync() {
      const max = this.list.scrollWidth - this.list.clientWidth;
      this.classList.toggle('is-rk-static', max <= 1);
      this.prev.disabled = this.list.scrollLeft <= 1;
      this.next.disabled = this.list.scrollLeft >= max - 1;
    }
  }

  customElements.define('rk-reviews', RkReviews);
}
